import React, {useContext, useState} from 'react'
import NoteContext from '../context/note/NoteContext.js';

const AddNote = (props) => {
    const context = useContext(NoteContext);
    const [note, setNote] = useState({title:"", description:"", tag:""})
    const { addNote, textColor, backgroundColor } = context;

    const handleClick = (e) => {
        e.preventDefault();
        addNote(note.title, note.description, note.tag)
        setNote({title:"", description:"", tag:""})
        props.showAlert("success", "Note Added Successfully")
    }
    const onChange = (e) => {
        setNote({...note, [e.target.name]: e.target.value})
    }
  return (
    <div className='mt-4' style={textColor}>
      <h2>Add Notes</h2>
      <form className='container my-3'>
        <div className="mb-3">
          <label htmlFor="title" className="form-label">Title</label>
          <input type="text" className="form-control" id="title" name='title' aria-describedby="emailHelp" value={note.title} style={{...backgroundColor, ...textColor}} onChange={onChange} minLength={5} required={true} />
        </div>
        <div className="mb-3">
          <label htmlFor="description" className="form-label">Description</label>
          <input type="text" className="form-control" id="description" name='description' value={note.description} style={{...backgroundColor, ...textColor}} onChange={onChange} minLength={5} required={true} />
        </div>
        <div className="mb-3">
          <label htmlFor="tag" className="form-label">Tag</label>
          <input type="text" className="form-control" id="tag" name='tag' value={note.tag} onChange={onChange} style={{...backgroundColor, ...textColor}} minLength={3} required={true} />
        </div>
       
        <button disabled={note.title.length<5 || note.description.length<5} type="submit" className="btn btn-dark" onClick={handleClick}>Submit</button>
      </form>
    </div>
  )
}

export default AddNote
